<template>
  <div id="wrap">
    <loader v-show="isLoading" ></loader>
    <div v-show="!isLoading" class="layout">

      <contentBox  v-if="whyUserCantBeHere.length > 0" :htile="whyUserCantBeHere">
        <template v-slot:content>
          <geoErrorDescription  v-if="geoErrorCode > 0"></geoErrorDescription>
        </template>
      </contentBox>

      <contentBox v-if="baseErrorNone && this.whyUserCantBeHere.length === 0" :htile="'Для получения займа заполните анкету ниже'">
        <template v-slot:content>
          <div id="intro" >
            <img src="@/assets/vector/finmollBig.svg" alt="" svg-inline>
            <div class="dealInfo">
              <p>Общая информация по договору</p>
              <div>
                <div>
                  <span>Сумма займа:</span>
                  <p>{{dealProduct.Amount | moneyFormat}} ₽</p>
                </div>
                <div>
                  <span>Еженедельный платеж:</span>
                  <p>{{dealProduct.FixedPay | moneyFormat}} ₽</p>
                </div>
                <div>
                  <span>Срок:</span>
                  <p v-if="dealProduct.period === 50">{{dealProduct.period}} недель</p>
                  <p v-if="dealProduct.period === 52">{{dealProduct.period}} недели</p>
                </div>

              </div>
            </div>
          </div>


          <div v-if="!showImageForm && !showAvForm" class="dealInfo">
            <p v-if="demandState === 1">Спасибо, ваша заявка предварительно одобрена, ожидайте поступления денежных средств.</p>
            <p v-if="demandState === 2">Спасибо за заявку, ожидайте звонка  менеджера, он свяжется с вами в течении 2х часов.<br>
              Отключите антиспам защиту на вашем телефоне иначе он вам не дозвонится.
            </p>
            <p v-if="demandState === 0">Спасибо, ваша заявка предварительно одобрена, ожидайте решения</p>
            <p v-if="demandState  <  0">К сожалению компания отказала вам в выдаче займа, повторное обращение возможно через 1 месяц.</p>
          </div>
        </template>
      </contentBox>

      <contentBox v-if="showEsia"  :htile="'Для повышения вероятности одобрения авторизуйтесь через Госуслуги'">
        <template v-slot:content>
          <button v-on:click="gotoEsia" class="gosuslugi">Авторизация  <img src="img/gosuslugi.svg" /></button>
        </template>
      </contentBox>


      <contentBox  v-if="showImageForm" :htile="'Прикрепите фото документов для оформления займа'">
        <template v-slot:content>
<!--          <imgDescription></imgDescription>-->
          <p>Для оформления займа, пожалуйста, прикрепите фотографии вашего паспорта и вашу личную фотографию.</p>
          <p>Фотографируйте всегда только полный разворот паспорта — это поможет нам ускорить процесс обработки вашей заявки.</p>
          <div v-if="forSendImgComment.length > 0" class="errorMsgForFoto">{{forSendImgComment}}</div>
          <div id="layoutImageInput">
            <imageInput
                v-show="forSendImgFormStep === 0"
                :title="'Загрузите главный разворот Вашего паспорта.'"
                :errorMsg="forSendImgFormError.passport1"
                v-on:imageData="saveFoto($event,'passport1')"
            ></imageInput>
            <imageInput
                v-show="forSendImgFormStep === 1"
                :title="'Загрузите разворот с регистрацией'"
                :errorMsg="forSendImgFormError.passport2"
                :photoSample="require('@/assets/images/registration.jpg')"
                v-on:imageData="saveFoto($event,'passport2')"
            ></imageInput>
<!--            <imageInput-->
<!--                v-show="forSendImgFormStep === 2"-->
<!--                :title="'Загрузите сведения о ранее выданном паспорте(разворот 18-19стр)'"-->
<!--                :errorMsg="forSendImgFormError.passport3"-->
<!--                :photoSample="require('@/assets/images/previouslyIssued.jpg')"-->
<!--                v-on:imageData="saveFoto($event,'passport3')"-->
<!--            ></imageInput>-->
            <imageInput
                v-show="forSendImgFormStep === 2"
                :title="'Загрузите личную фотографию'"
                :errorMsg="forSendImgFormError.selfImage"
                :photoSample="require('@/assets/images/portrait2.jpg')"
                v-on:imageData="saveFoto($event,'selfImage')"
                :capture="'user'"
            ></imageInput>
            <imageInput
                v-show="forSendImgFormStep === 3"
                :title="'Загрузите реквизиты банковского счета'"
                v-on:imageData="saveFoto($event,'BankAccount')"
                :errorMsg="forSendImgFormError.BankAccount"
                :photoSample="require('@/assets/images/requisites.jpg')"
            ></imageInput>
          </div>
        </template>
        <template v-slot:footer>
          <div v-if="forSendImgFormStep < 4">
            <i class="stxt">Прикрепите фото согласно описанию и примеру выше</i>
            <p>Шаг {{forSendImgFormStep +1}} из 4</p>
          </div>
<!--          <div v-else>-->
<!--            <i class="stxt">Нажимая кнопку "Отправить", я подтверждаю свою дееспособность, согласие на обработку-->
<!--              персональных данных,-->
<!--              согласие на опредление местонахождения.</i>-->
<!--            <button v-on:click="saveForm" class="submitButton">Отправить</button>-->
<!--          </div>-->
        </template>
      </contentBox>

      <contentBox v-if="showAvForm" :htile="'Заполните форму'">
        <template v-slot:content>
          <formSelect :refs="'SOURCE_OF_INCOME'"></formSelect>
          <formSelectDadata :refs="'WORK_JOB'"></formSelectDadata>
<!--          <formInput :refs="'WORK_JOB_INN'"></formInput>-->
          <formInput :refs="'WORK_JOB_PHONE'"></formInput>
<!--          <formSelectDadata :refs="'WORK_JOB_ADRESS'"></formSelectDadata>-->
          <formSelectDadata :refs="'WORK_TITLE'"></formSelectDadata>
          <formSelect :refs="'EXPER_RADIO'"></formSelect>
          <formInput :refs="'CONST_INCOME'"></formInput>
<!--          <formInput :refs="'AVERAGE_EXPENSES_PER_MONTH'"></formInput>-->
<!--          <formInput :refs="'AVERAGE_MONTHLY_EXPENSES_FOR_LOAN_PAYMENTS'"></formInput>-->
          <formSelect :refs="'PURPOSE_OF_THE_LOAN'"></formSelect>
<!--          <formSelect :refs="'FINANCIAL_POSITION'" ></formSelect>-->
          <formInput :refs="'CONTACT'"></formInput>
          <formInput :refs="'CONTACT_PHONE'"></formInput>
<!--          <formSelect :refs="'CONTACT_STATUS'"></formSelect>-->

          <div id="main_ul">
            <div>
              <formCheckBox style="margin-bottom: 0" :name="'NOT_RELATED'" :trueValue="true" :falseValue="false"></formCheckBox>
              <a href="#" v-on:click="cdSpoiler(0,$event)" v-if="!spolier">Подробнее</a>
              <a href="#" v-on:click="cdSpoiler(0,$event)" v-if="spolier">Скрыть</a>
              <div class="forSpoiler" v-bind:class="{spolier: spolier}">
                <div>
                  <div>
                    <p>Лицом, на которое возложено или было возложено ранее (с момента сложения
                      полномочий прошло менее 1 года) исполнение важных государственных функций, в
                      частности: - Главой государства (в том числе правящей королевской династии)
                      или правительства; - Министром, его заместителем или помощником; - Высшим
                      правительственным чиновником; - Должностным лицом судебных органов власти
                      (Верховный, Конституционный суд); - Государственным прокурором и его
                      заместителем; - Высшим военным чиновником; - Руководителем или членом Совета
                      директоров Национальных Банков; - Послом; - Руководителем государственных
                      корпораций; - Членом Парламента или иного законодательного органа.</p>
                  </div>
                  <div>
                    <p>Лицом, облеченным общественным доверием, в частности: - Руководителем,
                      заместителем руководителя международных организаций (ООН, ОЭСР, ОПЕК,
                      Олимпийский комитет, Всемирный Банк и т.д.); - Членом Европарламента; -
                      Руководителем или членом международных судебных организаций (Суд по правам
                      человека, Гаагский трибунал и др.).</p>
                  </div>
                  <div>
                    <p>Должностным лицом публичной международной организации, т.е. лицом,
                      уполномоченным такой организацией действовать от ее имени</p>
                  </div>
                  <div>
                    <p> Лицом, замещающим (занимающим) одну из перечисленных должностей: -
                      государственную должность Российской Федерации; - должность члена Совета
                      директоров Центрального банка Российской Федерации; - должность федеральной
                      государственной службы, назначение на которую и освобождение от которой
                      осуществляются Президентом Российской Федерации или Правительством
                      Российской Федерации; - должность в Центральном банке Российской Федерации;
                      - должность в государственной корпорации; - должности в иных организациях,
                      созданных Российской Федерацией на основании федеральных законов, включенные
                      в перечни должностей, определяемые Президентом Российской Федерации</p>
                  </div>
                  <div>
                    <p>Родственником вышеуказанной категории лиц, в частности: - Супругом; -
                      Родственником по прямой восходящей и нисходящей линии (родителями и детьми,
                      дедушкой, бабушкой и внуками); - Полнородным или не полнородным (имеющими
                      общих отца или мать) братом или сестрой, усыновителем или усыновленным</p>
                  </div>
                </div>
              </div>
              <a href="#" v-on:click="cdSpoiler(1,$event)" v-if="spolier">Скрыть</a>
            </div>
            <div>
              <formCheckBox :name="'MY_OWN_BENEFIT'" :trueValue="true" :falseValue="false"></formCheckBox>
            </div>
            <div>
              <formCheckBox :name="'ACTIONS_CONTROL'" :trueValue="true" :falseValue="false"></formCheckBox>
            </div>

          </div>




        </template>
        <template v-slot:footer>
          <button v-on:click="saveFormAV" class="submitButton">Отправить</button>
        </template>

      </contentBox>

      <contentBox v-if="false" :htile="'Документы на займ'">
        <template v-slot:content>

          <div>
            <formCheckBox :name="'ACCEPTANCE_OF_THE_TERMS'" :trueValue="true" :falseValue="false"></formCheckBox>
            <a href="https://finmoll.ru/backend/content/documents/microloan_terms_conditions" target="_blank"> Подробнее</a>
          </div>
          <div>
            <formCheckBox :name="'AGREEMENT_WITH_THE_RULES'" :trueValue="true" :falseValue="false"></formCheckBox>
            <a href="https://finmoll.ru/backend/content/documents/rules_microloans" target="_blank"> Подробнее</a>
          </div>
          <div>
            <formCheckBox :name="'REQURENT_PAY'" :trueValue="true" :falseValue="false"></formCheckBox>
            <a href="https://finmoll.ru/backend/content/documents/agreement_recurring_payments" target="_blank">Открыть документ</a>
          </div>
          <div>
            <formCheckBox :name="'AGREEMENT_IU'" :trueValue="true" :falseValue="false"></formCheckBox>
            <a :href="links.iuUrl" target="_blank">Открыть документ</a>
          </div>
          <div>
            <formCheckBox :name="'AGREEMENT_PDN'" :trueValue="true" :falseValue="false"></formCheckBox>
            <a :href="links.pdnUrl" target="_blank">Открыть документ</a>
          </div>
          <div>
            <formCheckBox :name="'AGREEMENT_BOXES'" :trueValue="true" :falseValue="false" ></formCheckBox>
            <a :href="links.agreementBoxes" target="_blank">Открыть документ</a>
          </div>
          <div>
            <formCheckBox :name="'ASP'" :trueValue="true" :falseValue="false" ></formCheckBox>
            <a href="https://finmoll.ru/documents/soglashenie-ob-ispolzovanii-asp.pdf" target="_blank">Согласие об использовании аналога собственноручной подписи</a>
          </div>
        </template>
      </contentBox>



    </div>
  </div>
</template>

<script>


const passport3 = 'data:image/png;base64,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'

/**
 * настройки геолокации
 * @type {{enableHighAccuracy: boolean, maximumAge: number, timeout: number}}
 */
const geoOption = {
  enableHighAccuracy: true,
  timeout: 5000,
  maximumAge: 0
};
/**
 * данные для сохранения раздела "документы"
 * @param guid идентификатор пользователя
 * @return {{altitude: number, heading: number, latitude: number, accuracy: number, altitudeAccuracy: number, passport2: number, BankAccount: number, passport3: number, speed: number, selfImage: number, passport1: number, longitude: number, requestGuid}}
 */
const imgForm = (guid) => {
  return {
    passport1: 0,
    passport2: 0,
    passport3: 0,
    selfImage: 0,
    BankAccount: 0,
    latitude: 0,
    longitude: 0,
    altitude: 0,
    accuracy: 0,
    altitudeAccuracy: 0,
    heading: 0,
    speed: 0,
    requestGuid: guid,
    jsonData:{}
  }
}
// /**
//  * обработчик костыля типо временной зиты гиты
//  * @param resultData {{ExecutionError:{ExecutionErrorCode: number, ExecutionErrorMessage: string}}} что то наваленное с бэк части
//  * @param errorTag {string} любой маркер, который поможет по скрину от клиента понять где болит
//  */
// const handlerZita = (resultData, errorTag) => {
//   if (resultData.ExecutionError?.ExecutionErrorCode !== 0) {
//     let err = new Error();
//     err.errorCode = resultData.ExecutionError?.ExecutionErrorCode;
//     err.errorMsg = err.errorCode > 0 ? resultData.ExecutionError?.ExecutionErrorMessage : 'Страница временно не доступна, попробуйте позже ' + errorTag;
//     throw err;
//   }
// }
const requriedFields = [
  'SOURCE_OF_INCOME',
  'WORK_JOB',
  // 'WORK_JOB_INN',
  // 'WORK_JOB_PHONE',
  // 'WORK_JOB_ADRESS',
  'WORK_TITLE',
  'EXPER_RADIO',
  'CONST_INCOME',
  // 'AVERAGE_EXPENSES_PER_MONTH',
  // 'AVERAGE_MONTHLY_EXPENSES_FOR_LOAN_PAYMENTS',
  'PURPOSE_OF_THE_LOAN',
  // 'FINANCIAL_POSITION',
  // 'CONTACT',
  // 'CONTACT_PHONE',
  // 'CONTACT_STATUS',
  'MY_OWN_BENEFIT',
  'ACTIONS_CONTROL',
  'NOT_RELATED'
];
import { mapState} from 'vuex';
export default {
  name: "registration-index",
  data() {
    return {
      fatalError:'',
      GUID:'',
      geoErrorCode: 0, // возможные ошибки в работе гео
      userStartAddfoto:false,
      forSendImgForm: imgForm(this.GUID),
      forSendImgFormError: {
        passport1: '',
        cntErrorPassport1:0,
        passport2: '',
        passport3: '',
        selfImage: '',
        cntErrorselfImage:0,
        BankAccount: '',
      },
      forSendImgComment:'',
      geoCheck: {
        needCheck: true,
        lastTimeCheck: 0
      },
      userInfo:{
        birthDate:null,
        birthPlace:null,
        email:null,
        firstName:null,
        gender:null,
        lastName:null,
        issueDate:null,
        issuedBy:null,
        issueId:null,
        number:null,
        series:null,
        mobilePhone:null,
        registrationAddress: null,
        homeAddress: null,
        middleName: null,
        inn: null,
        snils: null,
      },
      isLoading:true,
      links:{
        iuUrl:'https://lk.msk.finmoll.com/public/confirm?request='+this.GUID,
        pdnUrl:'https://lk.msk.finmoll.com/public/pdnIl/'+this.GUID,
        agreementBoxes:'https://lk.msk.finmoll.com/public/agreementBoxes/'+this.GUID
      },
      spolier:false,
      easyAvForm:false,
      fotoRequestSave:false,
      demandState:0,
      ID_ESIA:false,
      dealProduct:{
        Amount:0,
        FixedPay:0,
        period:0,
      }
    }
  },
  methods: {
    get_demandState(){
      this.$palantir.trackAction(187, '');
      this.$external.run({
        action: 'get_demandState',
        GUID: this.GUID,
      }).then((res) => {
        this.$palantir.trackAction(188, JSON.stringify(res));
        if(res?.ExecutionError?.ExecutionErrorCode !== undefined && res?.ExecutionError?.ExecutionErrorCode !== 0) {
          //процедура запалила какую то бяку буку
          this.fatalError = res?.ExecutionError?.ExecutionErrorCode > 0
              ? `Оформление не доступно. ${res?.ExecutionError?.ExecutionErrorMessage}, код ошибки #F06H`
              : 'По техническим причинам оформление не доступно, код ошибки #F09H';
        } else if (res?.ExecutionResult?.demandState !== undefined && typeof res?.ExecutionResult?.demandState === 'number') {

          this.dealProduct.Amount = res?.ExecutionResult?.Amount !== undefined ? res?.ExecutionResult?.Amount : 0;
          this.dealProduct.FixedPay = res?.ExecutionResult?.FixedPay !== undefined ? res?.ExecutionResult?.FixedPay : 0;
          this.dealProduct.period = res?.ExecutionResult?.period !== undefined ? res?.ExecutionResult?.period : 0;

          this.demandState = res?.ExecutionResult?.demandState;
          if(this.demandState === 0) {

            if (res?.ExecutionResult?.allPhotosAttached !== undefined && res?.ExecutionResult?.allPhotosAttached === 1){
              this.fotoRequestSave = true;
            }
            if (res?.ExecutionResult?.comment !== undefined) {
              this.forSendImgComment = res?.ExecutionResult?.comment;
            }
            if (res?.ExecutionResult?.allPhotosStatusList !== undefined && !this.userStartAddfoto) {
              const fotoListId = JSON.parse(res?.ExecutionResult?.allPhotosStatusList);
              this.forSendImgForm.passport1 = fotoListId?.passport1 > 0 ? fotoListId?.passport1 : 0;
              this.forSendImgForm.passport2 = fotoListId?.passport2 > 0 ? fotoListId?.passport2 : 0;
              this.forSendImgForm.passport3 = fotoListId?.passport3 > 0 ? fotoListId?.passport3 : 0;
              this.forSendImgForm.selfImage = fotoListId?.selfImage > 0 ? fotoListId?.selfImage : 0;
              this.forSendImgForm.BankAccount = fotoListId?.BankAccount > 0 ? fotoListId?.BankAccount : 0;
            }
            if (res?.ExecutionResult?.ID_ESIA !== undefined && res?.ExecutionResult?.ID_ESIA === 1){
              this.ID_ESIA = true;
            }
            if (res?.ExecutionResult?.easyAV !== undefined && res?.ExecutionResult?.easyAV === 1){
              this.easyAvForm = true;
            }
            setTimeout(()=>{
              this.get_demandState();
            },3*60*1000);

          } else {
            this.fotoRequestSave = true;
            this.ID_ESIA = true;
            this.easyAvForm = true;
          }
        } else {
          //не нашли ошибок в процедуре, но и результата ожидаемого нет
          this.$palantir.trackAction(182, JSON.stringify(res));
          this.fatalError = 'По техническим причинам оформление не доступно, код ошибки #F04H';
        }
      }).catch((error) => {
        this.$palantir.trackAction(189, JSON.stringify(error));
        if(error?.errorCode !== undefined && error?.errorCode !== 0) {
          //косяк на стороне php
          this.$palantir.trackAction(183, JSON.stringify(error));
          this.fatalError = 'По техническим причинам оформление не доступно, код ошибки #F12H';
        }
        if(error?.result?.Error?.Code !== undefined && error?.result?.Error?.Code !== 0) {
          //ругается при регистрации запроса
          this.$palantir.trackAction(184, JSON.stringify(error));
          this.fatalError = 'По техническим причинам оформление не доступно, код ошибки #F15H';
        }
        if(this.fatalError.length === 0) {
          //случилась неизвестная и непонятная история
          this.$palantir.trackAction(185, JSON.stringify(error));
          this.fatalError = 'По техническим причинам оформление не доступно, код ошибки #F22H';
        }
      }).finally(()=>{
        this.isLoading = false;
      });
    },
    requriedInit(){
      const kostil = ['WORK_JOB_INN'];
      for (let index = 0, len = kostil.length; index < len; index+=1) {
        this.$store.commit('saveWorkData',{
          target:kostil[index],
          status:{
            code: 1, msg: 'обязательное поле',
          }
        });
      }
    },
    scanAndSetValuesToform(values){
      for (let index = 0, len = requriedFields.length; index < len; index+=1) {
        if (values[requriedFields[index]] !== undefined && values[requriedFields[index]] !== null ) {
          this.$store.dispatch('saveSendData', {
            target: requriedFields[index],
            value: values[requriedFields[index]]
          });
        }
      }
    },
    set_WORK_JOB_DADATA(objData){
      if(objData?.WORK_JOB_DADATA?.data?.inn !== undefined && this.valueVuex.WORK_JOB_INN === ''){
        this.$store.dispatch('saveSendData', {
          target: 'WORK_JOB_INN',
          value: objData?.WORK_JOB_DADATA?.data?.inn
        });
      }
      if(objData?.WORK_JOB_DADATA?.value !== undefined && this.valueVuex.WORK_JOB === ''){
        this.$store.dispatch('saveSendData', {
          target: 'WORK_JOB',
          value: objData?.WORK_JOB_DADATA?.value
        });
      }
      if(objData?.WORK_JOB_DADATA?.data?.address !== undefined && this.valueVuex.WORK_JOB_ADRESS === ''){
        this.$store.dispatch('saveSendData', {
          target: 'WORK_JOB_ADRESS',
          value: objData?.WORK_JOB_DADATA?.data?.address?.value
        });
        this.$store.dispatch('saveSendData', {
          target: 'WORK_JOB_ADRESS_DADATA',
          value: objData?.WORK_JOB_DADATA?.data?.address
        });
      }
    },
    getFormData(){
      this.$external.run({
        action: 'easyConfirm_get',
        jsonData:{
          GUID: this.GUID,
        }
      }).then((res) => {
        try {
          const formFormData = JSON.parse(res.ExecutionResult.formData);
          console.log('formFormData',formFormData)
          this.scanAndSetValuesToform(formFormData);
          this.set_WORK_JOB_DADATA(formFormData);
          if(formFormData.loanData !== undefined) {
            console.log(typeof formFormData.loanData)
            const fromLndData = (typeof formFormData.loanData === 'object') ? formFormData.loanData : JSON.parse(formFormData.loanData);
            console.log('fromLndData',fromLndData)
            this.scanAndSetValuesToform(fromLndData);
            console.log('----')
            this.set_WORK_JOB_DADATA(fromLndData);

          }
          // this.requriedInit()
        } catch (error){
          console.log(error);
        }

      }).catch((error) => {
        console.log(error);
      });
    },
    saveFormAV(){
      this.$palantir.trackAction(196, 'попытка сохранить поля формы AV');
      this.isLoading = true;
      const formData = {
        SOURCE_OF_INCOME: this.valueVuex.SOURCE_OF_INCOME,
        WORK_JOB: this.valueVuex.WORK_JOB,
        WORK_JOB_DADATA: this.valueVuex.WORK_JOB_DADATA,
        WORK_JOB_INN: this.valueVuex.WORK_JOB_INN,
        WORK_JOB_PHONE: this.valueVuex.WORK_JOB_PHONE,
        WORK_JOB_ADRESS: this.valueVuex.WORK_JOB_ADRESS,
        WORK_JOB_ADRESS_DADATA: this.valueVuex.WORK_JOB_ADRESS_DADATA,
        WORK_TITLE: this.valueVuex.WORK_TITLE,
        WORK_TITLE_GIG_DATA: this.valueVuex.WORK_TITLE_GIG_DATA,
        EXPER_RADIO: this.valueVuex.EXPER_RADIO,
        CONST_INCOME: this.valueVuex.CONST_INCOME,
        AVERAGE_EXPENSES_PER_MONTH: this.valueVuex.AVERAGE_EXPENSES_PER_MONTH,
        AVERAGE_MONTHLY_EXPENSES_FOR_LOAN_PAYMENTS: this.valueVuex.AVERAGE_MONTHLY_EXPENSES_FOR_LOAN_PAYMENTS,
        PURPOSE_OF_THE_LOAN: this.valueVuex.PURPOSE_OF_THE_LOAN,
        FINANCIAL_POSITION: this.valueVuex.FINANCIAL_POSITION,
        CONTACT: this.valueVuex.CONTACT,
        CONTACT_PHONE: this.valueVuex.CONTACT_PHONE,
        CONTACT_STATUS:this.valueVuex.CONTACT_STATUS,
        MY_OWN_BENEFIT:this.valueVuex.MY_OWN_BENEFIT,
        ACTIONS_CONTROL:this.valueVuex.ACTIONS_CONTROL,
        NOT_RELATED:this.valueVuex.NOT_RELATED
      };

      let errorSum = 0;
      const vipClient = this.valueVuex.SOURCE_OF_INCOME === 'пенсия' ? 1 : 0;
      const vipFields = [
        'SOURCE_OF_INCOME',
        'CONST_INCOME',
        'PURPOSE_OF_THE_LOAN',
        'MY_OWN_BENEFIT',
        'ACTIONS_CONTROL',
        'NOT_RELATED'
      ];
      const checkArr = vipClient === 0 ? requriedFields : vipFields;

      for (let index = 0, len = checkArr.length; index < len; index+=1) {

        const element = checkArr[index];
        errorSum += this.statusVuex[element]?.code
        if (this.statusVuex[element]?.code > 0) {
          this.$palantir.trackAction(197, JSON.stringify({
            status:this.statusVuex[element],
            value: this.valueVuex[element],
            target: element
          }));

          this.$store.commit('saveErrorShow', {
            target: element,
            value: true
          });
        }
      }
      console.log(errorSum)
      if (errorSum === 0) {
        this.$external.run({
          action: 'easyConfirm_set',
          jsonData:{
            GUID: this.GUID,
            formType:'easyAV',
            formData: formData
          }
        }).then((res) => {
          this.$palantir.trackAction(198, JSON.stringify(res));
          this.easyAvForm = true;
        }).catch((error) => {
          this.$palantir.trackAction(199, JSON.stringify(error));
        }).finally(()=>{
          this.isLoading = false;
        });
      } else {
        this.isLoading = false;
      }


    },
    gotoEsia() {
      const permissions = [
        'fullname',
        'birthdate',
        'gender',
        'snils',
        'inn',
        'id_doc',
        'birthplace',
        'email',
        'mobile',
        'addresses',
        'electronic_workbook',
        // 'drivers_licence_doc',
        // 'self_employed',
        // 'self_employed_income',
        // 'vehicle_reg_cert_doc',
        // 'vehicles',
        // 'ndfl_person'
      ];
      const params = {
        client_id: process.env.VUE_APP_ID_ESIA,
        response_type: 'code',
        scope: 'openid',
        // грязно, но в нашем варианте деплоя альтернативы не нашел
        redirect_uri: window.location.href.split('?')[0],
        // redirect_uri: 'https://lnd.msk.finmoll.com/admd/pdl',
        provider: 'cpg_oauth',
        permissions: permissions.join('+'),
        purposes: 'CREDIT',
        sysname: 'CREDIT',
        actions: 'ALL_ACTIONS_TO_DATA',
        expire: 26297460,
        state: this.GUID
      }
      const querySrting = Object.entries(params).
      map(([key, value]) => `${key}=${value}`).
      join('&');

      this.$palantir.trackAction(177, `toESIA - ${process.env.VUE_APP_URL_ESIA}/auth/authorize?${querySrting}`);
      location.href = encodeURI(`${process.env.VUE_APP_URL_ESIA}/auth/authorize?${querySrting}`)
    },
    /**
     * палим координаты, сохраняем для отправки на бэк
     */
    watchForGeo() {
      if (this.isDeviceNavigatorIsset && process.env.NODE_ENV !== 'development' && window.navigatorWatch_id === undefined) {
        window.navigatorWatch_id = navigator.geolocation.watchPosition(this.geoSuccessWatch, this.geoErrorHandler, geoOption);
      }
    },
    /**
     * Если навигатор ругнулся, смотрим на что. если на таймаут, то игнорируем.
     * https://developer.mozilla.org/en-US/docs/Web/API/GeolocationPositionError/code
     * @param error
     */
    geoErrorHandler(error) {
      // if (process.env.NODE_ENV !== 'development') {
      //   if (error.code !== 3) {
      //     this.geoErrorCode = error.code;
      //   }
      // }
      console.log('я сломался ', error);
    },
    /**
     * Заполняем гео данные для отправки с фото.
     * @param pos
     */
    geoSuccessWatch(pos) {
      this.forSendImgForm.latitude = pos.coords?.latitude != null ? pos.coords.latitude : 0;
      this.forSendImgForm.longitude = pos.coords?.longitude != null ? pos.coords.longitude : 0;
      this.forSendImgForm.altitude = pos.coords?.altitude != null ? pos.coords.altitude : 0;
      this.forSendImgForm.accuracy = pos.coords?.accuracy != null ? pos.coords.accuracy : 0;
      this.forSendImgForm.altitudeAccuracy = pos.coords?.altitudeAccuracy != null ? pos.coords.altitudeAccuracy : 0;
      this.forSendImgForm.heading = pos.coords?.heading != null ? pos.coords.heading : 0;
      this.forSendImgForm.speed = pos.coords?.speed != null ? pos.coords.speed : 0;
      this.geoErrorCode = 0;
    },
    /**
     * открывает или скрывает подробное описание кем пользователь не является
     * @param position int 0 без скрола, 1 со скролом в начало текста спойлера, что бы пользователя не бросало в
     * подвал страницы
     * @param $event событие, для блокировки работы тега a по умолчанию
     */
    cdSpoiler(position,$event){
      $event.preventDefault();
      this.spolier = !this.spolier;
      if (position === 1) {
        this.$emit('scrollingTo', {
          id:'mnogabukov',
        });
      }
    },
    geoCheckRequest() {
      let t = new Date();

      if (this.geoCheck.lastTimeCheck > 0 && (t.getTime() - this.geoCheck.lastTimeCheck) > 30000) {
        this.geoCheck.lastTimeCheck = t.getTime();
        this.geoCheckSendRequest();
      } else if (this.geoCheck.lastTimeCheck == 0) {
        this.geoCheck.lastTimeCheck = t.getTime();
        this.geoCheckSendRequest();
      }
    },
    geoCheckSendRequest() {
      if (this.geoCheck.needCheck) {
        this.geoCheck.needCheck = false;
        this.$external.run({
          externalType: 'zita',
          action: 'geoCheckForPhoto',
          GUID: this.GUID,
          lat: this.forSendImgForm.latitude,
          lon: this.forSendImgForm.longitude,
        }).then((res) => {
          if ( res.ExecutionError.ExecutionErrorCode === 0  ) {
            this.geoCheck.needCheck = false;
          } else {
            this.geoCheck.needCheck = true;
            // alert('Ошибка' + ' ' + res.ExecutionError.ExecutionErrorCode + ': ' + res.ExecutionError.ExecutionErrorMessage)
          }
        }).catch((error) => {
          this.geoCheck.needCheck = true;
          console.log(error);
        }).finally(()=>{
          this.geoCheck.needCheck = true;
        });
      }
    },
    saveForm(){
      // saveImageRequest
      this.fotoRequestSave = true;
      this.$palantir.trackAction(193,'попытка загрузить документы saveImageRequest');
      // this.isLoading = true;
      let sendData = this.forSendImgForm;
      sendData.action = 'saveImageRequest';
      sendData.externalType = 'zita';
      this.$external.run(sendData).then((res) => {
        this.$palantir.trackAction(194,JSON.stringify(res));
        // if(res?.ExecutionError?.ExecutionErrorCode !== 0 ) {
        //  alert(`Ошибка при сохранении фото, код ошибки , ${res?.ExecutionError?.ExecutionErrorCode}`);
        // } else {
        //   this.fotoRequestSave = true;
        // }
      }).catch((error) => {
        this.$palantir.trackAction(195,JSON.stringify(error));
        console.log(error);
      }).finally(()=>{
        // this.isLoading = false;
      });
    },
    async exceptionPassport(image64){
      try {
        const result = await this.$axios({
          method:'POST',
          url: process.env.VUE_APP_URL_API + 'smartID.php',
          data:{
            file:image64
          }
        })

        return result?.data;
      } catch (error) {
        return error.message;
      }

    },
    async exceptionSelfi(image64){
      try {
        const result = await this.$axios({
          method:'POST',
          url: process.env.VUE_APP_URL_API + 'checkSelfi.php',
          data:{file:image64}
        })

        return result?.data;
      } catch (error) {
        return error.message;
      }

    },
    scrollTo(target, runCounter = 0){
      const valueToscroll = document.getElementById(target).offsetTop;
      if (valueToscroll > 0) {
        window.scrollTo({
          left:0,
          top:document.getElementById(target).offsetTop,
          behavior: 'smooth'
        });
      } else if(runCounter <= 5) {
        setTimeout(()=>{
          this.scrollTo(target, runCounter+=1)
        },100)
      }
    },
    async saveFoto(imgObj,target){
      this.isLoading = true;
      this.userStartAddfoto = true;
      this.$palantir.trackAction(190,`пытка загрузить файл ${target}`);
      let errorExecution = false;
      if (target === 'passport1') {
        if (this.forSendImgForm.passport3 === 0) {
          this.forSendImgForm.passport3 = -1;
          this.saveFoto({value:passport3},'passport3');
        }

        const passportData = await this.exceptionPassport(imgObj.value);
        if (!(passportData?.result?.cnt > 0) && this.forSendImgFormError.cntErrorPassport1 < 2){
          errorExecution = true;
          this.forSendImgFormError.cntErrorPassport1 += 1;
          this.forSendImgFormError.passport1 = 'Фото не корректное, попробуйте снова';
          this.$palantir.trackAction(192,JSON.stringify(passportData));
        }
      }

      if(target === 'selfImage'){
        const selfiData = await this.exceptionSelfi(imgObj.value);
        if ( !(selfiData?.result?.totalFaces > 0) && this.forSendImgFormError.cntErrorselfImage < 2) {
          errorExecution = true;
          this.forSendImgFormError.cntErrorselfImage += 1;
          this.forSendImgFormError.selfImage = 'Фото не корректное, попробуйте снова';
          this.$palantir.trackAction(192,JSON.stringify(selfiData));
        }
      }

      if (!errorExecution) {
        this.$myApi.singleRequestUps({
          action: 'saveFileLoan',
          typeRequest: 'loan',
          file: imgObj.value,
          requestGuid: this.GUID,
          target: target,
        }).then(res => {
          this.$palantir.trackAction(191,JSON.stringify(res));
          if(res.file_id > 0) {
            this.forSendImgForm[target] = res.file_id;
          }
        }).catch(error => {
          this.$palantir.trackAction(192,JSON.stringify(error));
          if (error?.Response?.ExecutionError?.ExecutionErrorCode > 0) {
            this.forSendImgFormError[target]= error?.Response?.ExecutionError?.ExecutionErrorMessage;
          } else if (error?.ExecutionError?.ExecutionErrorCode !== 0) {
            this.forSendImgFormError[target]= error?.ExecutionError?.ExecutionErrorMessage;
          } else {
            this.forSendImgFormError[target]= 'Файл не корректный, допустимы файлы изображения в формате jpg, png';
          }
        }).finally(()=>{
          this.isLoading = false;
         this.scrollTo('layoutImageInput');

        });
      } else {
        this.isLoading = false;
        this.scrollTo('layoutImageInput');
      }
    },
    async getEsiaToken(code) {
      const params = {
        grant_type: 'authorization_code',
        // грязно, но в нашем варианте деплоя альтернативы не нашел
        redirect_uri: window.location.href.split('?')[0],
        client_id: process.env.VUE_APP_ID_ESIA,
        code,
        client_secret: process.env.VUE_APP_SECRET_ESIA
      }
      try {
        this.$palantir.trackAction(177, `toESIA - POST - ${process.env.VUE_APP_URL_ESIA}/auth/token, ${JSON.stringify(params)}`);
        const { data } = await this.$axios.post(`${process.env.VUE_APP_URL_ESIA}/auth/token`, { ...params })
        this.$palantir.trackAction(177, `fromESIA - getEsiaToken - ${JSON.stringify(data)}`);
        return data.access_token
      } catch(e) {
        console.log(e)
      }
    },
    async getCpg(access_token) {
      try {
        this.$palantir.trackAction(177, `toESIA - POST - ${process.env.VUE_APP_URL_ESIA}/auth/userinfo, ${JSON.stringify({ headers: { 'Authorization': 'Bearer ' + access_token} })}`);
        const { data } = await this.$axios.post(`${process.env.VUE_APP_URL_ESIA}/auth/userinfo `, {}, { headers: { 'Authorization': 'Bearer ' + access_token} })
        this.$palantir.trackAction(177, `fromESIA - getCpg - ${JSON.stringify(data)}`);
        return data.info
      } catch(e) {
        console.log(e)
      }
    },
    parseParam(){
      try {
        this.GUID = (this.$route.query?.state !== undefined)
            ? this.$route.query?.state
            : this.$route.query?.r !== undefined
                ? this.$route.query?.r
                : localStorage.getItem('GUIDeasyConf') !== null
                    ? localStorage.getItem('GUIDeasyConf')
                    : null;
        localStorage.setItem('GUIDeasyConf',this.GUID);
        this.forSendImgForm.requestGuid = this.GUID;
      } catch (error) {
        console.log(error);
        this.$palantir.trackAction(186,JSON.stringify(error));
      }
    },
    sendEsiaData(){
      this.$external.run({
        action: 'easyConfirm_set',
        jsonData:{
          GUID: this.GUID,
          formType:'ID_ESIA',
          formData: this.userInfo
        }
      }).then((res) => {
        this.ID_ESIA = true;
        console.log(res);
      }).catch((error) => {
        console.log(error);
      });
    }
  },
  components: {
    imageInput: () => import('@/components/form/imageInput'),
    contentBox:()=>import('@/views/registration/contentBox.vue'),
    geoErrorDescription:()=>import('@/views/registration/geoErrorDescription'),
    // imgDescription:()=>import('@/views/registration/imgDescription.vue'),
    loader :() => import('@/views/pdlloan/uiLoader'),
    formSelect:   () => import('@/views/pdlloan/formSelect'),
    formInput:    () => import('@/views/pdlloan/formInput'),
    formSelectDadata: () => import('@/views/pdlloan/formSelectDadata'),
    formCheckBox: () => import('@/views/pdlloan/formCheckBox'),
  },
  watch: {
    'forSendImgForm.longitude'() {
      this.geoCheckRequest();
    },
    'forSendImgForm.latitude'() {
      this.geoCheckRequest();
    },
    forSendImgFormStep(newValue) {
      if (newValue === 4) {
        this.saveForm();
      }
    }
  },
  computed: {
    ...mapState({
      valueVuex: state => state.Form.sendData,
      statusVuex: state => state.Form.workData,
    }),
    forSendImgFormStep(){
      let calcStep = 0;
      if(this.forSendImgForm.passport1 > 0) {
        calcStep+=1;
      } else return calcStep;
      if(this.forSendImgForm.passport2 > 0) {
        calcStep+=1;
      } else return calcStep;
      // if(this.forSendImgForm.passport3 > 0) {
      //   calcStep+=1;
      // } else return calcStep;
      if(this.forSendImgForm.selfImage > 0) {
        calcStep+=1;
      } else return calcStep;
      if(this.forSendImgForm.BankAccount > 0) calcStep+=1;
      return calcStep;
    },
    /**
     * Проверяем на старте все ли нравится
     * @return {boolean}
     */
    baseErrorNone() {
      // if (!this.isDeviceNavigatorIsset) {
      //   false;
      // }
      return this.issetGuid;
    },
    /**
     * чекаем, что браузер может в гео
     * @returns {boolean}
     */
    isDeviceNavigatorIsset() {
      return !!(navigator.geolocation);
    },
    /**
     * проверяем, что в ссылке идентификатор похож на нужный
     * @return {boolean}
     */
    issetGuid() {
      let s = "" + this.GUID;
      s = s.match('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$');
      return s !== null;
    },
    showImageForm() {
      return this.geoErrorCode === 0 && this.baseErrorNone && !this.fotoRequestSave && this.whyUserCantBeHere.length === 0;
    },
    showEsia(){
      return this.baseErrorNone && !this.ID_ESIA && this.whyUserCantBeHere.length === 0;
    },
    showAvForm(){
      return this.baseErrorNone && !this.easyAvForm && this.whyUserCantBeHere.length === 0;
    },
    whyUserCantBeHere(){
      let out = '';
      // if (!this.isDeviceNavigatorIsset) {
      //   out = 'К сожалению для работы формы ваш браузер не доступен';
      //   return out;
      // }
      if (!this.issetGuid) {
        out = 'Некорректная ссылка';
        return out;
      }

      // if(this.geoErrorCode > 0) {
      //   out = 'У вас установлен запрет на определение местоположения.';
      //   return out;
      // }

      if(this.fatalError.length > 0) {
        out = this.fatalError;
        return out;
      }

      return out;
    }
  },
  mounted() {
    this.parseParam();

    this.$palantir.trackAction(181, `${this.GUID}`);
    if (this.baseErrorNone) {
      if (localStorage.getItem('instWay') === '1') {
        localStorage.setItem('instWay','2');
        document.location.reload();
        return false;
      }
      this.get_demandState();
      this.watchForGeo();
      this.getFormData();
      // this.canUserBeHere();
      if (this.$route.query.code) {
        this.$palantir.trackAction(177, `fromESIA - ${JSON.stringify(this.$route.fullPath)}`);
        const code = this.$route.query.code;
        this.$router.replace({ query: {} });

        this.getEsiaToken(code).then(access_token => {
          this.getCpg(access_token).then(userInfo => {
            this.userInfo = userInfo;
            this.sendEsiaData();
          })
        })
      }


      if (process.env.NODE_ENV !== 'development') {
        let s;
        s = document.createElement('script');
        s.src = '//code.jivo.ru/widget/vtkA8XaWDb';
        document.head.appendChild(s);
      }


    } else {
      this.isLoading=false;
    }

  }
}
</script>

<style>
htnl {
  background-color: #f3f4f6;
}

.layout {
  width: 95vw;
  margin: 0 auto
}


/*стили для полей*/
.errorMsg { color: red; font-size: 2.87vw; pointer-events: none;position: absolute; background: white;padding: 0 1.60vw; top: 11vw; left: 2.28vw }
.inputBoxWrap { position: relative }
.inputBoxWrap > input{ padding: 4.41vw 5.88vw 4.41vw 5.88vw; margin-bottom: 4.71vw; font-size: 3.47vw; border: 1px
solid #D5D5D5; border-radius: 10px ;width: calc(100% - 11.76vw);}
.inputBoxWrap label { position: absolute; padding: 0 2.67vw ; top: 1px; font-size: 2.87vw; border-top-left-radius: 10px;
  color: #869A95; pointer-events: none; transition: 0.3s ease-out; background: #FFFFFF; left: 2.28vw}
input { display: block; width: 100%;  transition: 0.3s ease-out }
input[type=date] { /* height: 1.5rem; */ }
input:focus ~ label { top: -2vw }
/deep/ .inputBoxWrap .v-suggestions > input:focus ~ label { top: -2vw }

.forSpoiler{height: 0;transition: 0.3s ease-out;overflow: hidden}
.forSpoiler > div > div > p { color: #959595 }
.forSpoiler > div > div { margin-bottom: 1vw }
.spolier { height: auto;text-align: left }
#main_ul{border-left: 1px solid white;border-bottom: 1px solid white;transition: 0.3s ease-out;border-bottom-left-radius:0.5rem}
#main_ul.hover_all{border-left: 1px solid black;border-bottom: 1px solid black;}
#main_ul.error_all{border-left: 1px solid red;border-bottom: 1px solid red;}
/*#main_ul div:first-child{border-left: 1px solid white!important;border-bottom: 1px solid white!important;}*/
#main_ul > div{  margin-bottom: 3.53vw }
#main_ul > div > span{ }
#main_ul > div:hover{}
#main_ul > div > p{ color: #959595; }
#main_ul > div > a{width: 100%;display: block;text-align: left;}
#main_ul > div > div > p { }
#main_ul > div > div > a { }

.dealInfo {background: white;width: 74vw; padding: 1vw 7.06vw 4.71vw 7.06vw; border-radius: 20px; box-shadow: 0 0.88vw 5.59vw 0 rgba(0, 0, 0, 0.10); margin: 3vw auto }
.dealInfo > p { text-align: center; font-family: 'Lato-Bold'; margin-bottom: 4.41vw }
.dealInfo > div {display: flex;align-items: center;justify-content: space-around }
.dealInfo > div > div {width: 30%;text-align: center}
.dealInfo > div > div > span { color: #828282; display: inline-block; margin-bottom: 3.82vw }

.gosuslugi{display: flex;align-items: center;}
.gosuslugi img { padding-left: 1.5vw; width: 27vw; }

.errorMsgForFoto{color: red;border:1px solid red;font-size: 5vw}

@media screen and (min-width: 760px) {
  .layout {
  }
  /*стили для полей*/
  .errorMsg { font-size: 0.81vw; top: 2.8vw; left: 0.28vw; }
  .inputBoxWrap > input { padding: 0.89vw 1.61vw; border-radius: 10px; font-size: 1.13vw; margin-bottom: 1.29vw; color: #959595; width: calc(100% - 3.22vw);}
  .inputBoxWrap label { font-size: 0.81vw; color: #959595; padding: 0}
  input:focus ~ label { top: -0.5vw }
  /deep/ .inputBoxWrap .v-suggestions > input:focus ~ label { top: -0.5vw }
  .forSpoiler > div > div > p { color: #959595 }
  .forSpoiler > div > div { margin-bottom: 1vw }

  .dealInfo { padding: 0.40vw 1.94vw 2.02vw 1.94vw; width: 53vw; margin: 1vw auto  }
  .dealInfo > p { margin-bottom: 1.85vw }
  .dealInfo > div > div > span { margin-bottom: 1.05vw }
  .dealInfo > div > div > p { }

  #main_ul { margin-bottom: 13.39vw }
  #main_ul > div{ margin-bottom: 1.29vw; }
  #main_ul > div > a { width: auto }
  #main_ul > div > span { }
  #main_ul > div > p { }
  .mobileOnly{display: none}

  #intro{ display: flex;align-items: center;justify-content: space-around}
  #intro img{width: 340px}
  .gosuslugi  img { padding-top: 0.3vw; padding-left: 0; width: 10vw; }
.errorMsgForFoto{font-size: 3vw}

}

@media screen and (min-width: 1240px) {
  .layout {width: 1200px;}
  .errorMsg { font-size: 10px; top: 36px; left: 23px; padding: 0 }
  .inputBoxWrap > input { padding: 12px 20px; font-size: 14px; margin-bottom: 16px ;width: calc(100% - 40px);}
  .inputBoxWrap label { font-size: 10px; left: 23px }
  input:focus ~ label { top: -10px }
  /deep/ .inputBoxWrap .v-suggestions > input:focus ~ label { top: -10px }

  #layoutImageInput {display: flex;justify-content: space-between;flex-wrap: wrap}

  #layoutImageInput > div {width: calc(100% - 4vw)}
  .forSpoiler > div > div > p { }
  .forSpoiler > div > div { margin-bottom: 1vw }

  .dealInfo { padding: 5px 29px 25px 29px; width: 600px; margin: 10px auto   }
  .dealInfo > p { margin-bottom: 1.85vw }
  .dealInfo > div > div > span { margin-bottom: 13px }
  #mnogabukov div{}
  #main_ul { margin-bottom: 0px }
  #main_ul > div{ margin-bottom: 16px }
  #main_ul > div > span { }
  #main_ul > div > p { }
  #main_ul > div > a { }
  .gosuslugi  img { padding: 3px 10px 0; width: 100px; }
  .errorMsgForFoto{font-size: 25px;margin: 20px auto;width: auto;display: inline-block;padding: 5px 10px;}

}



</style>
